(function ($, doc) {

    var $doc = $(doc),
        $body = $("body"),
        opener,
        closeButton = $("#menu-close-btn"),
        container = $("#off-canvas-container"),
        lastFocus,
        menu,
        menuside,
        overlay,
        openClass = "open";

    function showMenu() {
        container.removeClass("left");

        opener = $(this);
        lastFocus = doc.activeElement;
        menu = $(opener.data("target"));
        menuside = $(opener).data("menuside");
        overlay = $(".off-canvas-backdrop");

        var menuIsHidden = !menu.attr("aria-hidden") || menu.attr("aria-hidden").toLowerCase() === "true",
            docHeight = $doc.height(),
            focusTarget = $(opener.data("focus-target")),
            iphone4 = navigator.userAgent.match(/iPhone/i) !== null && window.screen.height === (960 / 2);

        // Set the height of the menu and overlay if needed (some older versions of safari cannot deal with 100% height)
        // Set position to absolute older versions of safari cannot deal with fixed
        if (iphone4 && menu.height() < docHeight) {
            menu.height(docHeight).css("position", "absolute");
            overlay.height(docHeight);
        }

        opener.attr("aria-expanded", menuIsHidden);
        menu.attr("tabIndex", -1)
            .toggleClass("open", menuIsHidden)
            .attr("aria-hidden", !menuIsHidden)
            .prop("inert", false);

        // focus the menu to make screen readers react to the opened menu
        // focus target specified by data attr or menu
        setTimeout(() => {
            if (menuIsHidden && focusTarget.length === 0) {
                menu.get(0).focus();
            } else if (menuIsHidden && focusTarget.length) {
                focusTarget.get(0).focus();
            }
        }, 250);

        // Show the backdrop
        $("#off-canvas-container").addClass(openClass);

        $("#off-canvas-container").addClass(menuside);

        $body.addClass("off-canvas-active");

        $doc.on("keyup", function (e) {
            if (e.keyCode === 27 && menu) {

                hideMenu();

                $doc.off("keyup");
            }
        });

        menu.on("keydown",
            function (e) {
                trapTabKey(e);
            })
            .on("offcanvasMenu.hide",
                () => {
                    hideMenu();
                });

        overlay.click(function () {
            hideMenu();
        });


        opener.addClass("open");

        closeButton.click(function () {
            hideMenu();
        });

        menu.trigger("offcanvasMenu.shown", [opener]);
    }

    function hideMenu() {
        if (!menu) { return; }

        menu.toggleClass("open", false)
            .attr("aria-hidden", true)
            .prop("inert", true);

        menu.off("keydown");

        opener.attr("aria-expanded", false);

        opener.removeClass("open");

        container.removeClass(openClass);

        opener.attr("data-opened", false);

        $body.removeClass("off-canvas-active");

        if (lastFocus) {
            lastFocus.focus();
        }

        menu.trigger("offcanvasMenu.hidden");

        cleanup();

    }

    function cleanup() {
        lastFocus = null;
        menu = null;
        overlay = null;
        opener = null;
        container.removeClass("left");
        container.removeClass("right");
    }

    function trapTabKey(e) {

        // if tab is pressed
        if (e.keyCode === 9) {
            var focusableItemsSelector = "a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, *[tabindex], *[contenteditable]",
                focusableItems = menu.find(focusableItemsSelector).filter(":visible"),
                focusedItem = $(":focus"),
                numberOfFocusableItems = focusableItems.length,
                focusedItemIndex = focusableItems.index(focusedItem);

            if (e.shiftKey) {
                //back tab
                // if focused on first item and user preses back-tab, go to the last focusable item
                if (focusedItemIndex === 0) {
                    focusableItems.last().focus();
                    e.preventDefault();
                }

            } else {
                //forward tab
                // if focused on the last item and user preses tab, go to the first focusable item
                if (focusedItemIndex === numberOfFocusableItems - 1) {
                    focusableItems.first().focus();
                    e.preventDefault();
                }
            }
        }

    }

    $.fn.offcanvasmenu = function () {

        return $(this).click(function (e) {
            e.preventDefault();


            if ($(this).hasClass("open")) {
                hideMenu();
            }
            else {
                $("[data-toggle='menu']").removeClass("open");
                $(".off-canvas-menu").attr("aria-hidden", true);
                showMenu.call(this);
            }

        });

    };

    $.fn.offcanvasmenu.defaults = {};

    $(function () {
        $("[data-toggle='menu']").offcanvasmenu();
    });

})(jQuery, document);